import React from "react";

class Label extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {
                background: this.props.color,
                float:"left",
                width:"15px",
                height:"2px",
                margin:"9px 2px",
            }
        }
    }

    render() {
        return (
            <div className="graph-label">
                <p><span style={this.state.style}></span>{this.props.cat}</p>

            </div>
        )
    }
}

export default Label;


// WEBPACK FOOTER //
// ./src/label.js